import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Group 37",
  "use": "icon-Group 37-usage",
  "viewBox": "0 0 30 80",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 80\" id=\"icon-Group 37\">\n  <g id=\"icon-Group 37_Group_37\" data-name=\"Group 37\" transform=\"translate(190 2242) rotate(180)\" opacity=\"0.5\">\n    <g id=\"icon-Group 37_Group_29\" data-name=\"Group 29\">\n      <rect id=\"icon-Group 37_Rectangle_38\" data-name=\"Rectangle 38\" width=\"30\" height=\"80\" transform=\"translate(160 2162)\" fill=\"#630106\" />\n      <path id=\"icon-Group 37_Path_2480\" data-name=\"Path 2480\" d=\"M292.03,2184.685l-3.984,3.984,3.984,3.984\" transform=\"translate(-114.546 13.815)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\" />\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Group 37.svg
// module id = LilQ
// module chunks = 3